// This file was auto generated by resource-sync tools.

import en_translation from './en/translation.json';
import ptBR_translation from './pt-BR/translation.json';
import zhCN_translation from './zh-CN/translation.json';

const resources = {
  namespaces: [
    {
      localeInfos: [{ locale: 'en', version: 12 }, { locale: 'pt-BR', version: 1 }, { locale: 'zh-CN', version: 7 }],
      i18nConfig: { apiKey: 'd95f1d097ccd429cb0b1cfd5f9e392f7', projectId: 32, namespaceId: 'ykrolebngv', namespaceName: 'translation' },
    },
  ],
  en: {
    translation: en_translation,
  },
  'pt-BR': {
    translation: ptBR_translation,
  },
  'zh-CN': {
    translation: zhCN_translation,
  },
};

export default resources;
